/**
 * Rebuy product recommendations for cart drawer
 * Simplified and optimized version
 */

// Exponer funciones globalmente para que puedan ser usadas por otros scripts
window.initCartRecommendations = null;
window.refreshCartCompletely = null;

(function() {
  // Control variables
  let lastUpdateTime = 0;
  let updateTimeout = null;
  const updateDelay = 500;
  
  // Exponer la función de inicialización globalmente
  window.initCartRecommendations = initCartRecommendations;
  
  // Exponer una función completa de actualización del carrito
  window.refreshCartCompletely = function() {
    refreshCart();
    initCartRecommendations();
  };
  
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    initCartRecommendations(); 
    
    // Monitor add to cart form submissions
    document.addEventListener('submit', function(event) {
      const form = event.target;
      if (form.action && form.action.includes('/cart/add')) {
        setTimeout(() => {
          initCartRecommendations();
        }, 2000);
      }
    });
    
    // Monitor standard cart events
    document.addEventListener('cart:change', () => scheduleUpdate('cart:change'));
    document.addEventListener('cart:updated', () => scheduleUpdate('cart:updated'));
    document.addEventListener('cart:refresh', () => scheduleUpdate('cart:refresh'));
    
    // Monitor cart drawer opening
    document.addEventListener('drawer:open', function(event) {
      if (event.detail && event.detail.drawer === 'cart') {
        scheduleUpdate('drawer open');
      }
    });
  });
  
  // Schedule update with delay to prevent too frequent calls
  function scheduleUpdate(source) {
    const now = Date.now();
    
    if (now - lastUpdateTime < 1000) {
      clearTimeout(updateTimeout);
    }
    
    updateTimeout = setTimeout(() => {
      initCartRecommendations();
      lastUpdateTime = Date.now();
    }, updateDelay);
  }
  
  // Initialize recommendations
  function initCartRecommendations() {
    const container = document.getElementById('product-recommendations-container');
    if (!container) return;
    
    // Try Rebuy API first
    tryRebuyAPI()
      .then(success => {
        if (!success) {
          getShopifyRecommendations();
        }
      })
      .catch(() => {
        getShopifyRecommendations();
      });
  }
  
  // Try to get data from Rebuy API
  function tryRebuyAPI() {
    return new Promise((resolve) => {
      // Widget ID and API key (replace with your actual keys)
      const widgetId = "60546";
      const apiKey = "d374fee3b8b7756c0e1cd7476d3372801eaa64ab";
      
      fetch(`https://rebuyengine.com/api/v1/custom/id/${widgetId}?key=${apiKey}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          // Process the data to extract products
          let processedProducts = [];
          
          if (Array.isArray(data)) {
            // Handle array response
            data.forEach((item, index) => {
              if (item && typeof item === 'object') {
                if (item.data && Array.isArray(item.data)) {
                  processedProducts = processedProducts.concat(item.data);
                } else {
                  processedProducts.push(item);
                }
              }
            });
          } else if (data && typeof data === 'object') {
            // Handle object response
            if (data.data && Array.isArray(data.data)) {
              processedProducts = data.data;
            } else if (data.products && Array.isArray(data.products)) {
              processedProducts = data.products;
            } else {
              processedProducts.push(data);
            }
          }
          
          if (processedProducts.length > 0) {
            renderProducts(processedProducts);
            resolve(true);
          } else {
            resolve(false); 
          }
        })
        .catch(error => {
          console.error('Error getting Rebuy data:', error);
          resolve(false);
        });
    });
  }
  
  // Get recommendations from Shopify as fallback
  function getShopifyRecommendations() {
    // Get the ID of the first product in cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items && cart.items.length > 0) {
          const productId = cart.items[0].product_id;
          
          if (productId) {
            // Get recommendations based on this product
            fetch(`/recommendations/products.json?product_id=${productId}&limit=4`)
              .then(response => response.json())
              .then(data => {
                if (data.products && data.products.length > 0) {
                  renderProducts(data.products);
                } else {
                  hideRecommendations();
                }
              })
              .catch(error => {
                console.error('Error getting recommendations:', error);
                hideRecommendations();
              });
          } else {
            hideRecommendations();
          }
        } else {
          hideRecommendations();
        }
      })
      .catch(() => {
        hideRecommendations();
      });
  }
  
  // Hide recommendations container
  function hideRecommendations() {
    const container = document.getElementById('product-recommendations-container');
    if (container) {
      container.style.display = 'none';
    }
  }
  
  // Render products from API response
  function renderProducts(products) {
    
    const container = document.getElementById('product-recommendations-container');
    if (!container) {
      console.error('Recommendations container not found');
      return;
    }
    
    // Get template
    const template = document.getElementById('rebuy-product-template');
    if (!template) {
      console.error('Product template not found');
      return;
    }
    
    // Clear container before adding new content
    container.innerHTML = '';
    
    // Filter products and show maximum 4
    if (!products || !products.length) {
      console.warn('No products to display');
      container.style.display = 'none';
      return;
    }
    
    const filteredProducts = products.slice(0, 4);
    
    // Create header
    const header = document.createElement('h3');
    header.textContent = 'Hello Beauty! Try this set for only $22!';
    container.appendChild(header);
    
    // Create products container
    const productsContainer = document.createElement('div');
    productsContainer.className = 'product-recommendations';
    
    // Add each product
    filteredProducts.forEach(product => {
      if (!product) {
        console.warn('Undefined product found');
        return;
      }
      

      try {
        // Get product data
        let imageUrl = '';
        if (product.image && product.image.src) {
          imageUrl = product.image.src;
        } else if (product.featured_image) {
          imageUrl = product.featured_image;
        } else if (product.images && product.images.length > 0) {
          imageUrl = product.images[0].src;
        }
        
        // Check for variants
        if (!product.variants || product.variants.length === 0) {
          console.warn('Product without variants:', product.title);
          return;
        }
        
        const price = parseFloat(product.variants[0].price).toFixed(2);
        const variantId = product.variants[0].id;
        const isAvailable = product.available !== false;
        
        // Clone the template
        const productNode = template.content.cloneNode(true);
        const productItem = productNode.querySelector('.product-item');
        
        // Set product data
        if (productItem) {
          // Remove template class
          productItem.classList.remove('template');
          
          // Set product ID attribute
          productItem.setAttribute('data-product-id', product.id);
          
          // Set image
          const imgContainer = productItem.querySelector('.product-image');
          if (imgContainer) {
            imgContainer.innerHTML = `<img src="${imageUrl}" alt="${product.title || ''}" loading="lazy">`;
          }
          
          // Set text data
          const vendorElement = productItem.querySelector('.product-vendor');
          if (vendorElement) vendorElement.textContent = product.vendor || '';
          
          const titleElement = productItem.querySelector('.product-title');
          if (titleElement) titleElement.textContent = product.title || 'Product';
          
          const priceElement = productItem.querySelector('.product-price');
          if (priceElement) priceElement.textContent = `$${price}`;
          
          // Update form
          const form = productItem.querySelector('form');
          if (form) {
            // Update form ID to be unique
            form.id = `ProductForm-${product.id}`;
            
            // Update variant ID
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput) {
              variantInput.value = variantId;
              if (!isAvailable) variantInput.disabled = true;
            }
            
            // Update button state based on availability
            const button = form.querySelector('button[type="submit"]');
            if (button) {
              if (!isAvailable) {
                button.disabled = true;
                button.querySelector('span').textContent = 'Sold out';
              } else {
                button.disabled = false;
                button.querySelector('span').textContent = 'Add to cart';
              }
            }
            
            // Add event listener for form submission
            form.onsubmit = function(event) {
              event.preventDefault();
              
              // Show loading state
              const submitButton = this.querySelector('button[type="submit"]');
              const loadingSpinner = this.querySelector('.loading-spinner');
              
              if (submitButton) submitButton.classList.add('loading');
              if (loadingSpinner) loadingSpinner.style.display = 'block';
              
              // Get form data
              const formData = new FormData(this);
              
              // Add product to cart
              fetch('/cart/add.js', {
                method: 'POST',
                body: formData
              })
              .then(response => response.json())
              .then(data => {
                
                // Update cart
                refreshCart();
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                if(cartDrawerWrapper && cartDrawerWrapper.classList.contains('is-emp')) {
                  cartDrawerWrapper.classList.remove('is-emp');
                }
                
                // Show success state
                if (submitButton) {
                  submitButton.classList.remove('loading');
                  submitButton.classList.add('added');
                  submitButton.querySelector('span').textContent = 'Added!';
                }
                if (loadingSpinner) loadingSpinner.style.display = 'none';
                
                // Reset button after delay
                setTimeout(() => {
                  if (submitButton) {
                    submitButton.classList.remove('added');
                    submitButton.querySelector('span').textContent = 'Add to cart';
                  }
                  
                  // Refresh recommendations
                  initCartRecommendations();
                }, 2000);
              })
              .catch(error => {
                console.error('Error adding product:', error);
                
                if (submitButton) {
                  submitButton.classList.remove('loading');
                  submitButton.textContent = 'Error - Try Again';
                }
                if (loadingSpinner) loadingSpinner.style.display = 'none';
                
                // Reset after delay
                setTimeout(() => {
                  if (submitButton) submitButton.textContent = 'Add to cart';
                }, 2000);
              });
            };
          }
        }
        
        // Add to container
        productsContainer.appendChild(productItem);
        
      } catch (error) {
        console.error('Error rendering product:', error);
      }
    });
    
    // Add products container to main container
    container.appendChild(productsContainer);
    container.style.display = 'block';
  }
  
  // Function to refresh the cart completely
  function refreshCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {


        updateCartCount(cart);
        updateTotalPrice(cart);
        // Habilitar el botón de checkout si el carrito tiene elementos
        updateCheckoutButton(cart.item_count);
        if (cart.item_count === 0) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && !cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.add('is-empty');
            
            setTimeout(() => {
              updateAfterPay(0);
              
              document.querySelectorAll('.cart-drawer__footer, .drawer__footer').forEach(footer => {
                if (footer) footer.style.display = '';
              });
            }, 100);
          }
        } else {
          // Remove empty class if cart has items
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
          
          const innerElements = document.querySelectorAll('.drawer__inner.is-empty, .cart-drawer.is-empty');
          innerElements.forEach(el => el.classList.remove('is-empty'));
        }
        
        // Open cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
        // Refresh cart contents via fetch
        refreshCartContents();
        
        // Update Afterpay widget directly
        updateAfterPay(cart.total_price);
        
        // Dispatch standard events
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      })
      .catch(error => console.error('Error refreshing cart:', error));
  }
  
  function updateCheckoutButton(itemCount) {
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    if (checkoutButton) {
      if (itemCount > 0) {
        checkoutButton.removeAttribute('disabled');
      } else {
        checkoutButton.setAttribute('disabled', 'disabled');
      }
    }
  }

  function updateTotalPrice(cart) {
    const totalValueElement = document.querySelector('.totals__total-value');
    if (!totalValueElement) return;
    
    const moneySpan = totalValueElement.querySelector('.money');
    if (!moneySpan) return;
    
    const totalCents = cart.total_price;

    const finalTotalCents = totalCents;
     
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(finalTotalCents / 100);
    
    moneySpan.textContent = formattedPrice;
    
  }

  function forceAfterPayVisible() {
    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (!cartDrawer) {
      return;
    }
    
    const afterpayElement = cartDrawer.querySelector('afterpay-placement');
    if (afterpayElement) {
      afterpayElement.style.display = '';
      afterpayElement.setAttribute('data-amount', '0');
       
      if (window.Afterpay) {
        window.Afterpay.initializeElements();
      }
    } else {
      console.log('Afterpay not exist in cart drawer');
    }
    
    const containers = [
      '.afterpay-cart-section',
      '.afterpay-placement-container',
      '.cart-afterpay-wrapper',
      '.cart-drawer__footer',
      '.drawer__footer'
    ];
    
    containers.forEach(selector => {
      const elements = cartDrawer.querySelectorAll(selector);
      elements.forEach(el => {
        el.classList.remove('hidden');
        el.classList.remove('hide');
        el.classList.remove('is-empty');
        
        el.style.display = '';
        
        let parent = el.parentElement;
        while (parent && parent !== cartDrawer && parent !== document.body) {
          parent.style.display = '';
          parent.classList.remove('hidden');
          parent.classList.remove('hide');
          parent = parent.parentElement;
        }
      });
    });
    
  }
  
  function updateAfterPay(totalCents) {
    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (!cartDrawer) {
      return;
    }
    
    const afterpayElement = cartDrawer.querySelector('afterpay-placement');
    if (afterpayElement) {
      
      const amount = totalCents > 0 ? (totalCents / 100) : 0;
      afterpayElement.setAttribute('data-amount', amount.toString());
      
      afterpayElement.style.display = '';
      
      const parentContainer = afterpayElement.closest('.afterpay-cart-section, .afterpay-placement-container');
      if (parentContainer) {
        parentContainer.style.display = '';
      }
      
      if (window.Afterpay) {
        window.Afterpay.initializeElements();
      }
      
      cartDrawer.querySelectorAll('.cart-afterpay-wrapper, .afterpay-cart-section').forEach(el => {
        if (el.classList.contains('hidden') || el.classList.contains('hide')) {
          el.classList.remove('hidden');
          el.classList.remove('hide');
        }
        
        el.style.display = '';
      });
    } else {

      const afterpayContainer = cartDrawer.querySelector('.afterpay-cart-section, .afterpay-placement-container');
      if (afterpayContainer) {
        afterpayContainer.style.display = '';
      }
    }
    
    const footer = cartDrawer.querySelector('.cart-drawer__footer, .drawer__footer');
    if (footer) {
      footer.style.display = '';
      footer.classList.remove('hidden');
      footer.classList.remove('hide');
    }
  }


  function updateCartCount(cart) {
    const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, .site-header__cart-count');
    if (cartCountElements.length > 0) {
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        element.setAttribute('aria-hidden', 'false');
        
        // Ensure counter is visible
        if (cart.item_count > 0) {
          element.style.display = 'flex';
          element.classList.remove('hide');
        }
      });
    }
  }
  
  // Refresh cart contents via section rendering
  function refreshCartContents() {
    fetch('/?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find cart elements to update
        const newItemsContainer = doc.querySelector('.drawer__cart-items-wrapper');
        const currentContainer = document.querySelector('.drawer__cart-items-wrapper, #CartDrawer-CartItems');
        
        if (newItemsContainer && currentContainer) {
          currentContainer.innerHTML = newItemsContainer.innerHTML;
        }
        
        // Update free shipping progress bar if present
        const shippingBar = document.querySelector('.shipping-progress-filled');
        const shippingMessage = document.querySelector('.shipping-message');
        if (shippingBar && shippingMessage) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              updateFreeShipping(cart.total_price, shippingBar, shippingMessage);
            });
        }
      })
      .catch(error => console.error('Error fetching cart section:', error));
  }
  
  // Update free shipping progress
  function updateFreeShipping(totalCents, barElement, messageElement) {
    const threshold = 5000; // $50 in cents
    const currentAmount = totalCents;
    
    if (currentAmount >= threshold) {
      barElement.style.width = '100%';
      messageElement.textContent = 'You qualify for free shipping!';
    } else {
      const percentage = Math.min(100, Math.round((currentAmount / threshold) * 100));
      const remaining = ((threshold - currentAmount) / 100).toFixed(2);
      
      barElement.style.width = `${percentage}%`;
      messageElement.textContent = `$${remaining} away from free shipping`;
    }
  }
})();